import { ArrowRight, Bell, BookOpenCheck, CheckCircle2, Play } from "lucide-react";
import Link from "next/link";

const COMING_SOON_CATEGORIES = [
  "Lesson planning",
  "Reading lessons",
  "Writing lessons",
  "Grammar lessons",
  "Tests and quizzes",
  "MENFPESRS staging",
] as const;

export function GuidesEmptyState() {
  return (
    <section className="bg-[#F4FBF1] px-4 py-14 text-slate-950 sm:px-6 sm:py-16 lg:px-8" aria-labelledby="guides-empty-heading">
      <div className="mx-auto grid max-w-[1200px] gap-8 lg:grid-cols-[minmax(0,0.95fr)_minmax(0,1.05fr)] lg:items-center">
        <div>
          <p className="inline-flex items-center gap-2 rounded-full border border-green-100 bg-white px-4 py-2 text-xs font-black text-[#087D2F] shadow-sm">
            <Bell className="h-4 w-4" strokeWidth={2.5} aria-hidden />
            Resource library in progress
          </p>
          <h2 id="guides-empty-heading" className="mt-5 text-3xl font-black leading-tight text-slate-950 sm:text-4xl">
            Guides are being prepared
          </h2>
          <p className="mt-4 max-w-2xl text-base font-medium leading-8 text-slate-700 sm:text-lg">
            We&apos;re building practical Moroccan English teaching guides with lesson planning, staging, tests,
            and classroom examples.
          </p>

          <div className="mt-7 flex flex-col gap-3 sm:flex-row">
            <Link
              href="/sign-up"
              className="inline-flex h-14 items-center justify-center gap-3 rounded-full bg-[#08A62F] px-7 text-base font-bold text-white shadow-[0_18px_34px_-22px_rgba(8,166,47,0.95)] transition-colors duration-150 hover:bg-[#078F2B] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-green-700"
            >
              Start free for 7 days
              <ArrowRight className="h-5 w-5" strokeWidth={2.6} aria-hidden />
            </Link>
            <Link
              href="/#how-it-works"
              className="inline-flex h-14 items-center justify-center gap-3 rounded-full border border-slate-200 bg-white px-6 text-base font-bold text-slate-950 shadow-sm transition-colors duration-150 hover:border-slate-300 hover:bg-slate-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-green-600"
            >
              <Play className="h-4 w-4 fill-current text-[#08A62F]" strokeWidth={2.3} aria-hidden />
              See how Darsi works
            </Link>
          </div>
        </div>

        <div className="grid gap-3 sm:grid-cols-2">
          {COMING_SOON_CATEGORIES.map((category) => (
            <article
              key={category}
              className="min-h-[132px] rounded-[22px] border border-green-100 bg-white p-5 shadow-[0_20px_60px_-48px_rgba(15,23,42,0.5)]"
            >
              <div className="flex items-center justify-between gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-green-50 text-[#08A62F] ring-1 ring-green-100">
                  <BookOpenCheck className="h-5 w-5" strokeWidth={2.5} aria-hidden />
                </span>
                <span className="rounded-full bg-amber-100 px-3 py-1 text-xs font-black text-amber-800">
                  Coming soon
                </span>
              </div>
              <h3 className="mt-4 text-lg font-black leading-tight text-slate-950">{category}</h3>
              <p className="mt-2 flex items-center gap-2 text-sm font-bold text-slate-500">
                <CheckCircle2 className="h-4 w-4 text-[#08A62F]" strokeWidth={2.5} aria-hidden />
                Markdown-ready
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
